module.exports = __webpack_public_path__ + "media/images/twitter-Icon-ad208993a97463549bb1db8023d763e9.png";